export default "__VITE_ASSET__BqYnyFfn__"